import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment as env } from '../../environments/environment';
import { Environment } from '../models/Environment';


@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {

  private environment: Environment;
  private http: HttpClient;

  constructor(private handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  load() {
    return this.http.get('environment.json')
      .toPromise()
      .then((environment: Environment) => {
        this.environment = environment;
      }).catch((e) => {
        console.error('Une erreur est survenue lors du chargement du fichier de variables d\'environnements !', env.production ? '' : e);

        if (!env.production) {
          console.warn(
              'Si le fichier src/environments/environment.json n\'est pas présent exécutez la commande suivante :',
              'cp src/environments/environment.example.json src/environments/environment.json',
          );
        }

        return Promise.reject();
      });
  }

  get<T extends keyof Environment>(attribute?: T): Readonly<Environment[T] | Environment> {
    if (attribute) {
      return this.environment[attribute];
    }

    return this.environment;
  }
}
